import { useEffect, useRef } from "react";

const STAGGER_MS = 90;
const TRANSITION_MS = 900;

export default function useScrollReveal() {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      return undefined;
    }

    root.querySelectorAll("[data-reveal-group]").forEach((group) => {
      group.querySelectorAll(":scope > [data-reveal]").forEach((el, index) => {
        el.style.setProperty("--kn-delay", `${index * STAGGER_MS}ms`);
      });
    });

    const timers = [];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          el.classList.add("is-visible");
          observer.unobserve(el);
          // Clear the stagger delay once revealed so hover transitions stay instant
          const delay = parseInt(el.style.getPropertyValue("--kn-delay"), 10) || 0;
          timers.push(
            setTimeout(() => el.style.setProperty("--kn-delay", "0ms"), delay + TRANSITION_MS),
          );
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" },
    );

    root.classList.add("kn-reveal-ready");
    root.querySelectorAll("[data-reveal]").forEach((el) => observer.observe(el));

    return () => {
      observer.disconnect();
      timers.forEach(clearTimeout);
    };
  }, []);

  return rootRef;
}
